import React from "react";
export const SearchTable = ({ tablaId }) => {

    const classNameInput = "text-white h-[30px] rounded px-4 w-[200px] bg-zinc-800 text-[13px] focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"
    const getByFilter = async (value) =>{
        const tabla = document.querySelector('#' + tablaId);
        const rows = tabla.children[1].children;
        const expresion = new RegExp(`${value}.*`, "i")

        for (let i = 0; i < rows.length; i++) {
            const cols = rows[i].children;
            let ocultar = true;

            for(let j = 0; j < cols.length; j++) {
                const value = cols[j].innerHTML;
                
                const booool = expresion.test(value);
                if (booool) {
                    ocultar = false;
                    break;
                }
            }

            rows[i].style.display = ocultar ? "none" : "";
        }
    }
    return (
    <>
        <div className="absolute right-[40px]" >
            <div className="absolute w-[39px] active" > 
                <input onChange={e => getByFilter(e.target.value)} className={ `${classNameInput} absolute text-[#FFFFFF] right-[40px] bg-[#27272a] rounded-md border-[#171313] pl-[10px]"`} type="text" placeholder="Búsqueda" autoComplete="off" />
            </div>
            <div id="divBtnBuscar" >
                <button className="absolute infoBusqueda tooltipstered right-[4px] mt-[2px] text-[#FFFFFF]">
                    <i className="fa fa-search" aria-hidden="true" />
                </button>
            </div>
        </div>
    </>
    );
}